import {z} from 'zod'

export const GetStepTypesRequestSchema = z.object({
  scope: z.enum(['JOURNEY', 'RTN']),
})
export type GetStepTypesRequest = z.infer<typeof GetStepTypesRequestSchema>

export const StepTypeSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  description: z.string(),
})
export type StepType = z.infer<typeof StepTypeSchema>

export const GetStepTypesResponseSchema = z.object({
  stepTypes: z.array(StepTypeSchema),
})
export type GetStepTypesResponse = z.infer<typeof GetStepTypesResponseSchema>
